import Textarea from "react-textarea-autosize";
import styled from "styled-components";

export const TextInput = styled(Textarea)`
	${({ theme }) => theme.containerStyles.roundedBlockStyle};
	resize: none;
	outline: none;
	overflow: hidden;
	border: none;
	padding: 20px 20px;
`;

export const NormalInput = styled("input")`
	${({ theme }) => theme.containerStyles.roundedBlockStyle};
	resize: none;
	outline: none;
	overflow: hidden;
	border: none;
	padding: 20px 20px;
`;

export const RoundedTextInput = styled(TextInput)`
	-webkit-appearance: none;
	border: 1px solid ${({ theme }) => theme.colors.lightergray};
	padding: 10px 12px 9px;
	border-radius: 16px;
	font-size: 0.8125rem;
`;

export const RoundedTextArea = styled("textarea")`
	-webkit-appearance: none;
	border: 1px solid ${({ theme }) => theme.colors.lightergray};
	padding: 10px 12px 9px;
	border-radius: 16px;
	font-size: 0.8125rem;
	resize: none;
	:focus {
		border: none;
		background: #ffffff;
		//box-shadow: 0px 0px 10px rgb(0 0 0 / 7%);
		border-radius: 10px;
	}
	overflow: auto;

	::-webkit-scrollbar {
		width: 8px;
		height: 4px;
	}

	/* Track */
	::-webkit-scrollbar-track {
		box-shadow: inset 0 0 5px grey;
		border-radius: 10px;
	}

	/* Handle */
	::-webkit-scrollbar-thumb {
		background: #007aff;
		border-radius: 10px;
	}

	/* Handle on hover */
	::-webkit-scrollbar-thumb:hover {
		background: #b30000;
	}
`;
